import { useRef, useCallback } from 'react-x';

export function useSwipe(callback, { touch=true, mouse=true, activateSwipeDistance=80 } = {}) {

  const startPoint = useRef(null);
  const endPoint = useRef(null);

  const onStart = useCallback(e => {
    endPoint.current = null;
    startPoint.current = e.clientX || e.targetTouches[0].clientX;
  });

  const onMove = useCallback(e => {
    endPoint.current = e.clientX || e.targetTouches[0].clientX;
  });

  const onEnd = useCallback(() => {
    const startPointX = startPoint.current;
    const endPointX = endPoint.current;

    if (!startPointX || !endPointX) return;
    const distance = startPointX - endPointX;
    const swipeRight = distance > activateSwipeDistance;
    const swipeLeft = distance < -activateSwipeDistance;
    
    if ( typeof callback === 'function') {
      callback(swipeRight, swipeLeft);
    }
  });

  const touchEvents = {
    onTouchStart: onStart,
    onTouchMove: onMove,
    onTouchEnd: onEnd
  };

  const mouseEvents = {
    onMouseMove: onMove,
    onMouseDown: onStart,
    onMouseUp: onEnd
  };

  return {
    ...( mouse && mouseEvents ),
    ...( touch && touchEvents )
  };
};